import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { HeaderComponent } from "./HeaderComponent"
import { FooterComponent } from "./FooterComponent"
import { isUnavConfigured, waitForUnavChrome } from "../../utils/unavChromeReady"

const UNAV_CONTENT_READY_TIMEOUT_MS = 12000

const addUnavScriptOnce = () => {
  const unavBaseUrl = process.env.REACT_APP_TMO_UNAV_ENV
  if (!unavBaseUrl) {
    return
  }
  if (document.getElementById("unav-script"))
  {
    return; // guard
  }
  const script = document.createElement("script");
  script.id = "unav-script";
  script.src = `${unavBaseUrl}/client/unav.min.js?unav=phx`;
  script.async = true;
  script.type = "text/javascript";
  document.body.appendChild(script);
};

const getQueryVariable = (variable) => {
  const query = window.location.search.substring(1)
  const vars = query.split("&")
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=")
    if (pair[0] === variable) { return pair[1] }
  }
  return (false)
}

export const LayoutComponent = ({ children }) => {
  const [hide, sethide] = useState(false)
  const [isMainContentReady, setIsMainContentReady] = useState(false)

  useEffect(() => {
    if (getQueryVariable("user_token")) {
      sethide(true)
      setIsMainContentReady(true)
      return
    }

    addUnavScriptOnce()
  }, [])

  useEffect(() => {
    if (hide) {
      return
    }

    if (!isUnavConfigured()) {
      setIsMainContentReady(true)
      return
    }

    return waitForUnavChrome(UNAV_CONTENT_READY_TIMEOUT_MS, () => {
      setIsMainContentReady(true)
    })
  }, [hide])

  return (
    <>
      {!hide && <HeaderComponent />}
      {isMainContentReady && children}
      {!hide && <FooterComponent />}
    </>
  )
}

LayoutComponent.propTypes = {
  children: PropTypes.element.isRequired
}
